import { ProviderDiscoveryState } from '../models/provider.model';

/**
 * Colour of a discovery state, shared by the providers grid and the provider header: green when
 * READY, red when the descriptor can't be fetched or used, orange when it's an unsupported
 * version. Null (neutral) when the provider is no longer listed or was never discovered —
 * nothing is wrong with it, core just isn't hearing from it.
 */
export function discoveryStateColor(state: ProviderDiscoveryState | null): 'green' | 'red' | 'orange' | null {
  switch (state) {
    case 'READY':
      return 'green';
    case 'UNREACHABLE':
    case 'INVALID':
      return 'red';
    case 'INCOMPATIBLE':
      return 'orange';
    default:
      return null;
  }
}

/** Translation key of a discovery state's label (`providers.discovery.state.*`). */
export function discoveryStateKey(state: ProviderDiscoveryState | null): string {
  return `providers.discovery.state.${state ?? 'NONE'}`;
}
